import { TFeeClassDetails } from 'redux/reducers/easFee/types';

export type TFeeClassDialogProps = {
	open: boolean;
	onClose: () => void;
	feeClassToEdit: TFeeClassDetails | null;
};

export type TFeeClassFormValues = {
	name: string;
	importSchemeFixedFee: number;
	importPercentageFee: number;
	minTradeValue: number;
	maxTradeValue: number;
	nonUnionFixedFee: number;
	unionFixedFee: number;
	nonUnionPercentageFee: number;
	unionPercentageFee: number;
	b2cDomesticPercentageFee: number;
	b2cDomesticFixedFee: number;
	minOrderCount: number;
	maxOrderCount: number;
	fcRepPercentageFee: number;
	fcRepFixedFee: number;
};

export type TFeeClassNumberField = Exclude<keyof TFeeClassFormValues, 'name'>;

export enum EFeeClassFieldKind {
	AMOUNT = 'amount',
	PERCENT = 'percent',
	COUNT = 'count',
}

export type TFeeClassField = {
	name: TFeeClassNumberField;
	label: string;
	kind: EFeeClassFieldKind;
};
